import type { Event } from '@hedepy/common/schemas/modules/event/event'
import type { Schedule } from '@hedepy/common/schemas/modules/schedule/schedule'
import type { TherapistDetail } from '@hedepy/common/schemas/modules/therapist/therapist'

import type { ClientStateType } from './ClientStateType'

export type ReviewType = {
  status?: number
  text?: string
  id?: number
  reason?: number
  eventId?: number
}

export type MinifiedTherapistType = {
  therapistId: number
  therapistUserId: number
  firstName: string
  lastName: string
  experience: number
  titleAfter?: string
  titleBefore?: string
}

export type MinifiedTherapistWithRecommendationsType = MinifiedTherapistType & {
  recommendations: number
  appointmentsCompleted?: number
}

export type TherapistPriceType = {
  serviceId: number
  price: number
}

export enum TherapistStatus {
  ACTIVE,
  LOCKED,
  SHADOW_BANNED,
  BOOSTED,
  NOT_ACTIVE,
  TESTING,
  TERMINATED,
  RESIGNED,
}

export const TherapistVerifiedCertificate = {
  TRAINEE_THERAPIST: 0,
  VERIFIED_THERAPIST: 1,
  PSYCHIATRIST: 2,
  PSYCHOLOGIST: 3,
  SPECIALIZED_PSYCHOLOGIST: 4,
  SHORT_THERAPIST: 5,
}

export type TherapistType = MinifiedTherapistWithRecommendationsType & {
  retentionSort?: string
  retention?: number
  majorSpecializations: number[]
  minorSpecializations?: number[]
  videoId: string
  description: string
  reviews?: ReviewType[]
  languages: string[]
  education?: string
  certificates?: string | string[]
  schedule?: Schedule[]
  appointments?: Event[]
  clients?: ClientStateType[]
  verifiedCertificate?: number
  price?: number
  image?: string // Therapist image for Client
  token?: string
  visible?: boolean
  prices?: TherapistPriceType[]
  slug: string
  services?: number[]
  insurances?: number[]
  sendIntroMessage: boolean
  introMessage: string
  id: number
  sex: number
  status: TherapistStatus | null
  trainings: number[]
  freeSchedulesCount: number
  freeSchedulesCountLongTerm: number
  houseNumber: string
  street: string
  city: string
  zip: string
  country: string
  vatin: string
  cin: string
  therapistCategoryId: number
  bookingWindowHours?: number
  hasOfflineTherapy: boolean
  office: TherapistDetail['office']
}

export type TherapistStateType = TherapistType
export type SpecializationOptionsType = { [key: string]: string }
